module.exports = __webpack_public_path__ + "static/img/3_4_1.671e2627.jpg";